export default "__VITE_ASSET__QCe$$HnO__"